import React, {useState, useEffect} from 'react';
import { Box, LinearProgress } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import logo from '../../assets/images/logo.png';

const styles = theme => ({
  root: {
    height: '90vh',
  },
  progress: {
    margin: '50px 30px',
    height: 10,
    backgroundColor: '#ebebef',
  },
});

const Progress = ({classes}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (progress <= 100) {
        setProgress(progress + 1);
      }
    }, 50);
    return () => clearInterval(interval);
  }, [progress]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      className={classes.root}>
      <Box flexDirection="column" display="flex">
        <img src={logo} alt="Logo" />
        <LinearProgress
          variant="determinate"
          className={classes.progress}
          value={progress}
        />
      </Box>
    </Box>
  );
};

export default withStyles(styles)(Progress);
